import type { TaskPrReview } from '@shared/factory-review';
import { StatusBadge } from '@/components/StatusBadge';
import { reviewBadgeHint, reviewBadgeMeta } from './review-badge';

/**
 * T-36: the second-model review of a PR, as a status badge: "Reviewed: 3 fixed, 1 not real", or
 * "Needs settling: 1 disputed" until a person settles it (SF-T-74), then "Reviewed: 3 fixed, 1 left as
 * is". The hint says who reviewed, in how many rounds, and what's left to settle.
 */
export function ReviewBadge({ review, size = 'sm' }: { review: TaskPrReview; size?: 'default' | 'sm' }) {
  return <StatusBadge size={size} meta={reviewBadgeMeta(review)} data-hint={reviewBadgeHint(review)} />;
}
